define('src/errors',['underscore'], function(_) {

    function NotImplementedError(message) {
        _.extend(this, {
            name: "NotImplementedError",
            message: message || ""
        });
        Error.apply(this, arguments);
    }
    NotImplementedError.prototype = Error.prototype;

    return {
        NotImplementedError: NotImplementedError,
    };

});

